<template>
  <div class="row" :class="{ 'row-right': isRight }">
    <li :class="{'right': isRight, 'left': !isRight}" >
      <div>
        <h1 class="date">{{education.year}}</h1>
        <h1>{{ education.heading }}</h1>
        <p>{{ education.description }}</p>
      </div>
    </li>
  </div>
</template>

<script>
export default {
  name: "TimelineElement",
  props: ['education','key'],
  computed: {
    isRight() {
      return this.education.id%2 === 0;
    }
  }
}
</script>

<style scoped>
li {
  position: relative;
  color: black;
  border-radius: 10px;
}
h1 {
  font-weight: 500;
  font-size: 25px;
  margin-bottom: 10px;
}
p {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
}
.date {
  transition: all .3s;
  font-size: 4rem;
}

@media (min-width: 768px) {
  .row-right{
    justify-content: right;
  }

  li {
    width: 50%;
    margin-bottom: 0;
  }

  .left {
    transform: translateX(-30px);
  }
  .left::before {
    right: -14px;
    transform: translate(50%, -50%);
  }

  .right::before {
    left: -16px;
    transform: translate(-50%, -50%);
  }
  li::before {
    content: "";
    position: absolute;
    height: 15px;
    width: 15px;
    background-color: black;
    top: 50%;
    border-radius: 100%;
    border: 3px solid #ffffff;
    transition: all .5s;
  }

  li:hover::before {
    background-color: white;
    border: 3px solid #f6483b;
  }
  li:hover .date {
    color: #f6483b;
    animation: breathing 2s ease-out infinite;
  }

  @keyframes breathing {
    0% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }

    50% {
      -webkit-transform: scale(0.95);
      -ms-transform: scale(0.95);
      transform: scale(0.95);
    }

    100% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }
  }
}
@media (max-width: 767px) {
  li::before {
    content: "";
    position: absolute;
    height: 1px;
    width: 90%;
    background-color: black;
    bottom: 5%;
  }
  li {
    margin-bottom: 10px;
  }
  .date {
    color:#f6483b;
  }
}
</style>